import { Box } from 'braid-design-system';

import {
  BlogButton,
  BuyABusinessButton,
  FindBrokersButton,
  FranchiseButton,
  HomeLogoButton,
  SellABusinessButton,
} from './Desktop/NavButtons';
import { ProfileActions } from './Desktop/ProfileActions';
import {
  desktopLargeHeaderContainerId,
  dropdownStateDataAttr,
  navHeaderBannerIds,
} from './utils/generalUtils';
import type { RenderVariant } from './utils/typeUtils';

import * as styles from './DesktopLargeHeader.css';

interface DesktopLargeHeaderProps {
  variant: RenderVariant;
  baseUrl: string;
  advertiserCentreUrl: string;
}

export const DesktopLargeHeader = ({
  variant,
  baseUrl,
  advertiserCentreUrl,
}: DesktopLargeHeaderProps) => (
  <Box
    component="header"
    id={desktopLargeHeaderContainerId}
    data={{
      testid: navHeaderBannerIds.desktopLarge,
      [dropdownStateDataAttr]: 'closed',
    }}
  >
    <nav aria-label="Main menu" className={styles.navHeaderContainer}>
      <Box className={styles.navHeaderContainerInner}>
        <Box display="flex" gap="small" alignItems="center">
          <HomeLogoButton baseUrl={baseUrl} />

          <BuyABusinessButton baseUrl={baseUrl} />
          <SellABusinessButton baseUrl={baseUrl} />
          <FranchiseButton baseUrl={baseUrl} />
          <FindBrokersButton baseUrl={baseUrl} />
          <BlogButton baseUrl={baseUrl} />
        </Box>

        <Box className={styles.navRightSideContainer}>
          <ProfileActions
            variant={variant}
            baseUrl={baseUrl}
            advertiserCentreUrl={advertiserCentreUrl}
          />
        </Box>
      </Box>
    </nav>
  </Box>
);
